









































































import Vue from 'vue';
import {
  Component,
  Mixins,
  Prop,
} from 'vue-property-decorator';

import { EventEmitter } from 'events';

import CommonController from '@/controllers/CommonController';

interface UploadFile {
  file: any;
  name: string;
  tempName: string;
  s3file: S3File | null;
  inEdit: boolean;
  inUpload: boolean;
  lastError: string;
}

interface S3File {
  bucket: string;
  filename: string;
}

@Component
export default class FileLoader extends Vue {
  @Prop({ required: true })
  bucket!: any;

  @Prop({ default: null })
  uploadEventEmitter!: EventEmitter;

  files: Array<UploadFile> = [];

  dummyFiles: Array<any> = [];

  beforeMount() {
    if (!!this.uploadEventEmitter === true) {
      this.uploadEventEmitter.on('upload', async (callback: () => {}) => {
        await this.loadAll();
        callback();
      });
    }
  }

  beforeDestroy() {
    if (!!this.uploadEventEmitter === true) {
      this.uploadEventEmitter.removeAllListeners();
    }
  }

  get loaded() {
    for (let i = 0; i < this.files.length; i += 1) {
      const file = this.files[i];
      if (file.inEdit === true || file.s3file === null || file.inUpload === true || file.lastError) {
        return false;
      }
    }
    return true;
  }

  get s3files() {
    return this.files.map((v: UploadFile) => v.s3file).filter((v: any) => v !== null);
  }

  async loadAll() {
    const promiseArray: Array<Promise<any>> = [];
    for (let i = 0; i < this.files.length; i += 1) {
      const file = this.files[i];
      if (this.fileIsDone(file)) {
        continue;
      }
      promiseArray.push(this.uploadFile(file));
    }
    await Promise.all(promiseArray);
  }

  fileIsDone(file: UploadFile): boolean {
    return !(file.inEdit === true || file.s3file === null || file.inUpload === true || file.lastError);
  }

  filesChanged(files: Array<any> = []) {
    for (let i = 0; i < files.length; i += 1) {
      const file = files[i];
      if (!this.files.find((v: UploadFile) => v.file.name === file.name)) {
        this.files.push({
          file,
          name: file.name,
          tempName: file.name,
          s3file: null,
          inEdit: false,
          inUpload: false,
          lastError: '',
        });
      }
    }
    this.dummyFiles = [];
    this.emitFilesState();
  }

  editFile(file: UploadFile) {
    file.inEdit = !file.inEdit;
    this.emitFilesState();
  }

  editDone(file: UploadFile) {
    file.inEdit = false;
    if (file.tempName !== file.name) {
      file.name = file.tempName;
      file.s3file = null;
    }
    this.emitFilesState();
  }

  deleteFile(file: UploadFile) {
    this.files.splice(this.files.findIndex((v: UploadFile) => v === file), 1);
    this.emitFilesState();
  }

  emitFilesState() {
    this.$emit('change', this.s3files, this.loaded);
  }

  async uploadFile(file: UploadFile) {
    file.inUpload = true;
    const {
      0: error,
      1: s3file,
    } = (await CommonController.uploadFileToS3(file.file, this.bucket, file.name)).result;
    if (error) {
      this.$bus.$emit('notification', `Ошибка загрузки файла: ${file.name} - ${error}`, 'error');
      this.emitFilesState();
      file.inUpload = false;
      file.lastError = error;
      return;
    }
    file.s3file = s3file;
    file.inUpload = false;
    file.lastError = '';
    this.emitFilesState();
  }
}

